// extracted by mini-css-extract-plugin
export default {"main":"System_main__9re3l"};